'use client';
import Grid from '@mui/material/Grid';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { HeaderVariationProps } from '@repo/ui/src/types';

interface Props {
  heading: string;
  headerVariation: HeaderVariationProps;
  headingStyle: any;
  lilHeading: string;
  description: string;
  buttons: Array<any>;
}

export const SplitToutContent = ({
  heading,
  headerVariation,
  headingStyle,
  lilHeading,
  description,
  buttons,
}: Props) => (
  <Section white gutterX gutterY basePadding className="tw-pb-0">
    <Grid container>
      <Grid item xs={12} md={5}>
        <ToutContent
          heading={heading}
          headerVariation={headerVariation}
          headingStyleVariant={headingStyle || 'h2'}
          lilHeading={lilHeading}
          forceDivider
          align="left"
        />
      </Grid>
      <Grid item md={1} />
      <Grid item xs={12} md={6}>
        <ToutContent description={description} buttons={buttons} align="left" />
      </Grid>
    </Grid>
  </Section>
);

export default SplitToutContent;